import { useEffect } from "react";
import { useCookieConsent } from "../hooks/useCookieConsent";
import { PIXEL_ENABLED } from "../lib/pixel";

const META_PIXEL_ID = "937015625323240";

export function MetaPixel() {
  const { hasMarketingConsent } = useCookieConsent();

  useEffect(() => {
    // Deactivated — the Meta Pixel is loaded & fired through GTM now.
    if (!PIXEL_ENABLED) {
      return;
    }

    if (!hasMarketingConsent) {
      return;
    }

    // If already loaded, just update consent + track
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("consent", "grant");
      window.fbq("track", "PageView");
      return;
    }

    // Load Meta Pixel only after consent
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        (n!.callMethod ? n!.callMethod.apply(n, arguments) : n!.queue.push(arguments));
      };
      if (!f._fbq) f._fbq = n;
      n!.push = n;
      n!.loaded = true;
      n!.version = "2.0";
      n!.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );

    window.fbq!("init", META_PIXEL_ID);
    window.fbq!("consent", "grant");
    window.fbq!("track", "PageView");
  }, [hasMarketingConsent]);

  return null;
}
